import { Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
// import { NotificationsService } from "angular2-notifications";
// import { ToastrService } from "ngx-toastr";
import { BaseDataService, NotificationService, QueryParameter } from "yt-ng-framework";

@Component({
    selector: 'yt-firma-kod-kupca',
    templateUrl: './firma-kod-kupca.component.html'
  })

  export class FirmaKodKupcaComponent implements OnInit{
    constructor(
        protected activeModal: NgbActiveModal,
        protected baseDataService: BaseDataService,
        // protected notificationService: NotificationsService
        protected toastrService: NotificationService
      )
      {
        
      }

      @Input() Parameters: QueryParameter[];

      ngOnInit() {
        
        this.formGroup.patchValue({FirmaSifraKodKupca: this.Parameters[0].Value});

      }
  
      formGroup = new FormGroup({
        FirmaSifraKodKupca: new FormControl(),
      })
  
      Save(){
        this.activeModal.close(
          this.formGroup.getRawValue()
        )
      }
  
      Close(){
          this.activeModal.dismiss();
      }
  }